import styled from 'styled-components';

export const FooterContainer = styled.footer`
    position: sticky;
    top: 0;
    background-color: #282828;
    padding: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    justify-content: space-between;
    align-items: center;
    z-index: 1000;
    text-align: center;

    p {
        background: linear-gradient(90deg, #ff6b8b, #6b5bff);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        font-weight: bold;
        margin: 0;
    }
`;
